export const SESSION_CHECK_INTERVAL_MS = 60_000;
export const DEFAULT_FUTURE_DAYS = 10;
export const WEEK_NAVIGATION_DAYS = 7;
